import React, { useCallback, useState } from "react";

import { Divider, Typography } from "@material-ui/core";

import Modal from "modules/core/components/modals/Modal";
import GlobalProjectsSelect, {
  IProjectSelection
} from "modules/projects/components/GlobalProjectSelectInput";

import { useSelectedProject } from "modules/projects/hooks/useSelectedProject";
import {
  AbilitySubject,
  PermissionAction,
  usePermissions
} from "modules/user/config/permissions/Can";

interface IProps {
  isOpen: boolean;
  permissionAction: PermissionAction;
  abilitySubject: AbilitySubject;
  allowedIds?: string[];
  onClose: () => void;
  onSuccess: (projectId: string) => void;
}

const SelectProjectModal: React.FC<IProps> = props => {
  const {
    isOpen,
    permissionAction,
    abilitySubject,
    allowedIds,
    onClose,
    onSuccess
  } = props;

  const { can } = usePermissions();

  const { rollupsType } = useSelectedProject();

  const [project, setProject] = useState<IProjectSelection | null>(null);
  const [error, setError] = useState("");

  const closeHandler = useCallback(() => {
    onClose();
    setProject(null);
    setError("");
  }, [onClose]);

  const submitHandler = useCallback(() => {
    if (!project) {
      setError("Select one project!");
      return;
    }

    onSuccess(project.value);
  }, [onSuccess, project]);

  return (
    <Modal
      title="Select Project"
      open={isOpen}
      onClose={closeHandler}
      onSubmit={submitHandler}
      type="primary"
      submitLabel="Proceed"
      maxWidth="xs"
    >
      <Typography variant="body2" color="textSecondary">
        You are currently on
        {rollupsType === "project" ? ' "All Projects"' : ' "Rollups"'} view.
        select a project and proceed.
      </Typography>

      <Divider variant="middle" style={{ margin: "25px 0" }} />

      <GlobalProjectsSelect
        value={project}
        multiple={false}
        error={error}
        canAccessProject={projectId =>
          can({ I: permissionAction, a: abilitySubject, in: projectId }) &&
          (!allowedIds || allowedIds.includes(projectId))
        }
        onChange={value => {
          if (value) {
            setError("");
          }

          setProject(value as IProjectSelection);
        }}
      />
    </Modal>
  );
};

export default SelectProjectModal;
